var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"page"},[_c('div',[_c('h2',[_vm._v("To reply to a message")]),_c('p',[_vm._v("Long press the message and click "),_c('strong',[_vm._v("Reply")]),_vm._v(" on the prompted\n                menu.\n            ")])])])])
}]

export { render, staticRenderFns }